import { Link, useLocation, useParams } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs'

const Crumbs = ({ path, to }: { path: string; to: string }) => {
  return (
    <Link
      style={{ textTransform: 'capitalize', textDecoration: 'none', fontSize: '0.875rem' }}
      to={to}
    >
      {path.replace('-', ' ')}
    </Link>
  )
}

export default function DynamicCrumbs() {
  const { pathname } = useLocation()

  const renderCrumbs = () => {
    const { slug } = useParams<string>()

    const paths = pathname.split('/').slice(1, pathname.length)

    return paths.map((path, idx) => {
      const route = idx === 0 ? `/${path}` : paths.reduce((acc, curr) => (acc += `/${curr}`), '')

      const crumbs = path !== slug && <Crumbs key={path} path={path} to={route} />

      return crumbs
    })
  }

  return (
    <Breadcrumbs aria-label='breadcrumb' separator='>'>
      {renderCrumbs()}
    </Breadcrumbs>
  )
}
